<template>
  <router-view></router-view>
</template>
<script>
export default {
  created() {
    const mode = this.$route.query.mode;
    console.log("🚀 ~ created ~ mode:", mode)
    if (mode === 'resetPassword') {
      this.$router.push({ name: 'reset-password', query: this.$route.query });
    } else if (mode === 'verifyEmail') {
      this.$router.push({ name: 'verify-email', query: this.$route.query });
    }else {
      this.$router.push({ name: 'Default' });
    } 
  },
};
</script>